class CollectionRefurbished extends HTMLElement {
  connectedCallback() {
    onLibReady(['vue'], this.#init.bind(this));
  }

  #init() {
    new Vue({
      el: this,
      data: {
        collectionHandle: 'refurbished-restaurant-appliances',
        collection: {},
        collections: [],
        variants: [],
        filterByCollectionValue: 'all-collections',
        paginate: {
          pageSize: 20,
          parts: 20,
        },
        loading: false,
        addingToCart: null,
      },
      template: `
              <div class="page-width">
                <div class="collection-refurbished" ref="container">
                    <template v-if="loading">
                      <div class="center">
                        Loading...
                      </div>
                    </template>
                    <template v-if="!loading">
                      <table class="collection-refurbished__table">
                        <thead>
                            <tr>
                              <th>Product</th>
                              <th>Price</th>
                              <th>Quantity</th>
                              <th></th>
                            </tr>
                        </thead>
              
                        <tbody v-if="variants.length">
                          <tr class="collection-refurbished__item" v-for="variant in variants.slice(0, paginate.pageSize)" :key="variant.id">
                            <td class="td-info">
                              <div class="collection-refurbished__item-inner">
                                <div class="collection-refurbished__item-img">
                                  <img :src="$options.filters.formatImage(variant.featured_image, '350x')">
                                </div>
                
                                <div class="collection-refurbished__item-info">
                                  <h3 class="collection-refurbished__item-name">
                                    {{ variant.product_title }}
                                  </h3>
                
                                  <div class="collection-refurbished__note">
                                    <p class="collection-refurbished__note-title">Note:</p>
                                    <p class="collection-refurbished__item-variant" v-if="variant.title !== 'Default Title'">
                                      <template v-for="(optionTitle, index) in variant.options_title">
                                        <span :key="optionTitle">{{ optionTitle }} : {{ variant.options[index] }}</span><br>
                                      </template>
                                    </p>
                                    <p>
                                      {{ variant.sku }}
                                    </p>
                                  </div>
                                  
                                  <div class="preview-photos" v-if="variant.product_images && variant.product_images.length > 1">
                                    <a href="#" @click.prevent="openGallery(variant.product_images)" area-label="Preview photos">Review photos</a>
                                  </div>
              
                                  <div class="collection-refurbished__item-bottom">
                                    <div class="collection-refurbished__price-inner">
                                      <span v-html="$options.filters.formatMoney(variant.price)" />
                                      <s v-if="variant.price < variant.compare_at_price" v-html="$options.filters.formatMoney(variant.compare_at_price)" />
                                    </div>
              
                                    <div class="quantity-mobile">
                                      <div class="quantity">
                                        <input type="number" pattern="[0-9]*" @change="changeQty(variant, $event)" :value="variant.quantity" class="quantity__input"/>
                                        <button class="quantity__button" name="minus" type="button" @click.prevent="decrementQty(variant)" aria-label="Decrement QTY">
                                          <svg x="0px" y="0px" viewBox="0 0 49.861 49.861">
                                            <path style="fill:#535b60;" d="M45.964,21.034H3.896C1.744,21.034,0,22.778,0,24.93s1.743,3.895,3.896,3.895h42.068
                                              c2.151,0,3.895-1.744,3.895-3.895S48.116,21.034,45.964,21.034z"/>
                                          </svg>
                                        </button>
                                        <button class="quantity__button" name="plus" type="button" @click.prevent="incrementQty(variant)" aria-label="Increment QTY">
                                          <svg x="0px" y="0px" viewBox="0 0 49.861 49.861">
                                            <path style="fill:#535b60;" d="M45.963,21.035H28.824V3.896C28.824,1.745,27.08,0,24.928,0s-3.896,1.744-3.896,3.896v17.139H3.895
                                              C1.744,21.035,0,22.779,0,24.931s1.743,3.895,3.895,3.895h17.139v17.139c0,2.151,1.744,3.896,3.896,3.896s3.896-1.744,3.896-3.896
                                              V28.826h17.139c2.152,0,3.896-1.744,3.896-3.895S48.115,21.035,45.963,21.035z"/>
                                          </svg>
                                        </button>
                                      </div>
                                    </div>
              
                                    <button class="button button--orange" :class="{'loading': addingToCart === variant.id}" :disabled="disabled(variant)" @click.prevent="handleAddToCart(variant)" aria-label="Add to cart">
                                      <svg x="0px" y="0px" width="510px" height="510px" viewBox="0 0 510 510">
                                        <path d="M153,408c-28.05,0-51,22.95-51,51s22.95,51,51,51s51-22.95,51-51S181.05,408,153,408z M0,0v51h51l91.8,193.8L107.1,306
                                          c-2.55,7.65-5.1,17.85-5.1,25.5c0,28.05,22.95,51,51,51h306v-51H163.2c-2.55,0-5.1-2.55-5.1-5.1v-2.551l22.95-43.35h188.7
                                          c20.4,0,35.7-10.2,43.35-25.5L504.9,89.25c5.1-5.1,5.1-7.65,5.1-12.75c0-15.3-10.2-25.5-25.5-25.5H107.1L84.15,0H0z M408,408
                                          c-28.05,0-51,22.95-51,51s22.95,51,51,51s51-22.95,51-51S436.05,408,408,408z"></path>
                                      </svg>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </td>
                
                            <td class="td-price">
                              <div class="collection-refurbished__price-inner">
                                <span v-html="$options.filters.formatMoney(variant.price)" />
                                <s v-if="variant.price < variant.compare_at_price" v-html="$options.filters.formatMoney(variant.compare_at_price)" />
                              </div>
                            </td>
                
                            <td class="td-quantity">
                              <div class="quantity">
                                <input type="number" pattern="[0-9]*" @change="changeQty(variant, $event)" :value="variant.quantity" class="quantity__input"/>
                                <button class="quantity__button" name="minus" type="button" @click.prevent="decrementQty(variant)" aria-label="Decrement QTY">
                                  <svg x="0px" y="0px" viewBox="0 0 49.861 49.861">
                                    <path style="fill:#535b60;" d="M45.964,21.034H3.896C1.744,21.034,0,22.778,0,24.93s1.743,3.895,3.896,3.895h42.068
                                      c2.151,0,3.895-1.744,3.895-3.895S48.116,21.034,45.964,21.034z"/>
                                  </svg>
                                </button>
                                <button class="quantity__button" name="plus" type="button" @click.prevent="incrementQty(variant)" aria-label="Increment QTY">
                                  <svg x="0px" y="0px" viewBox="0 0 49.861 49.861">
                                    <path style="fill:#535b60;" d="M45.963,21.035H28.824V3.896C28.824,1.745,27.08,0,24.928,0s-3.896,1.744-3.896,3.896v17.139H3.895
                                      C1.744,21.035,0,22.779,0,24.931s1.743,3.895,3.895,3.895h17.139v17.139c0,2.151,1.744,3.896,3.896,3.896s3.896-1.744,3.896-3.896
                                      V28.826h17.139c2.152,0,3.896-1.744,3.896-3.895S48.115,21.035,45.963,21.035z"/>
                                  </svg>
                                </button>
                              </div>
                              
                              <div v-if="variant.inventory_quantity > 0" class="inventory">
                                {{ variant.inventory_quantity }} available
                              </div>
                            </td>
                
                            <td class="td-button">
                              <button class="button button--orange" :class="{'loading': addingToCart === variant.id}" :disabled="disabled(variant)" @click.prevent="handleAddToCart(variant)" aria-label="Add to cart">
                                <svg x="0px" y="0px" width="510px" height="510px" viewBox="0 0 510 510">
                                  <path d="M153,408c-28.05,0-51,22.95-51,51s22.95,51,51,51s51-22.95,51-51S181.05,408,153,408z M0,0v51h51l91.8,193.8L107.1,306
                                    c-2.55,7.65-5.1,17.85-5.1,25.5c0,28.05,22.95,51,51,51h306v-51H163.2c-2.55,0-5.1-2.55-5.1-5.1v-2.551l22.95-43.35h188.7
                                    c20.4,0,35.7-10.2,43.35-25.5L504.9,89.25c5.1-5.1,5.1-7.65,5.1-12.75c0-15.3-10.2-25.5-25.5-25.5H107.1L84.15,0H0z M408,408
                                    c-28.05,0-51,22.95-51,51s22.95,51,51,51s51-22.95,51-51S436.05,408,408,408z"></path>
                                </svg>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </template>
                  </div>
              </div>  
            `,

      async mounted() {
        this.loading = true;
        await this.fetchCollection({handle: this.collectionHandle});
        this.loading = false;
        this.variants = this.getVariants(this.filterProductsByCollection(this.filterByCollectionValue));
        this.collections = this.getCollections(this.collection.products);
        const container = this.$refs.container;

        if (container) {
          window.addEventListener('scroll', async () => {
            const tableBottomHeight = container.offsetTop + container.offsetHeight;
            const scrollHeight = window.scrollY + window.innerHeight;

            if (scrollHeight >= tableBottomHeight && this.paginate.pageSize < this.variants.length) {
              this.paginate.pageSize += this.paginate.parts;
            }
          });
        }
      },

      methods: {
        async fetchCollection({handle, page = 1}) {
          const collection = await fetch(`/collections/${handle}?view=json&page=${page}`).then(response =>
            response.json(),
          );
          console.log({collection})
          if (collection) {
            if (+page === 1) {
              this.collection = collection;
            } else {
              this.collection.products.push(...collection.products);
            }

            if (collection.next_page) {
              const urlParams = new URLSearchParams(collection.next_page.url.split('?')[1]);
              await this.fetchCollection({handle: this.collectionHandle, page: urlParams.get('page')});
            }
          }
        },

        getVariants(products) {
          const variants = [];
          const voltage = Shopify.countryVoltage || Shopify.strings.v110;
          products.forEach(product => variants.push(...product.variants));
          return variants
            .filter(
              variant =>
                variant.inventory_quantity > 0 &&
                (!variant.options_title.includes(Shopify.strings.voltage) ||
                  variant.options.includes(voltage) ||
                  variant.options.includes(Shopify.strings.na)),
            )
            .map(variant => Object.assign({}, variant, {quantity: 1}));
        },

        getCollections(products) {
          const collections = [{title: 'All Collections', handle: 'all-collections'}];
          products.forEach(product => collections.push(...product.collections));
          const uniqueHandle = [...new Set(collections.map(collection => collection.handle))].filter(
            handle => handle !== this.collectionHandle,
          );
          return uniqueHandle.map(handle => collections.find(collection => collection.handle === handle));
        },

        filterProductsByCollection(handle) {
          let products = [];
          if (handle === 'all-collections') {
            products = this.collection.products;
          } else {
            products = this.collection.products.filter(product =>
              product.collections.some(collection => collection.handle === handle),
            );
          }
          return products;
        },

        openGallery(images) {
          if (!images) return;

          const gallery = images.map(image => ({
            src: image,
            thumb: image,
            typer: 'image',
          }));

          if (gallery.length) {
            Fancybox.show(gallery, {infinite: false});
          }
        },

        disabled(variant) {
          return (
            variant.inventory_management !== null &&
            variant.inventory_policy === 'deny' &&
            variant.inventory_quantity < 1
          );
        },

        changeQty(variant, evt) {
          if (evt.target.value > 0) {
            variant.quantity = evt.target.value;
          } else {
            evt.target.value = variant.quantity;
          }
        },

        decrementQty(variant) {
          if (variant.quantity - 1 > 0) {
            variant.quantity--;
          }
        },

        incrementQty(variant) {
          variant.quantity++;
        },

        handleAddToCart(variant) {
          if (this.addingToCart) return;
          this.addingToCart = variant.id;

          window.cartDrawer
            .add({
              items: [{id: variant.id, quantity: variant.quantity}],
            })
            .then(() => {
              this.addingToCart = null;
            });
        },
      },

      filters: {
        formatMoney(price) {
          return formatMoney(price);
        },

        formatImage(src, size, crop) {
          return formatImage(src, size, crop);
        },
      },
    });
  }
}

customElements.define('collection-refurbished', CollectionRefurbished);
